import { render } from "./Organization.vue?vue&type=template&id=c7bcbfee&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue?vue&type=script&lang=js"

import "./Organization.vue?vue&type=style&index=0&id=c7bcbfee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7bcbfee"]])

export default __exports__